import request from '../index.js'

// 债务管理API - 真实API版本
export const debtApi = {
  // 获取债务列表
  getDebts(params) {
    const { page = 1, pageSize = 10, status, debtorName, creditorName, amountMin, amountMax } = params || {}
    
    const queryParams = { page, limit: pageSize }
    if (status) queryParams.status = status
    if (debtorName) queryParams.debtorName = debtorName
    if (creditorName) queryParams.creditorName = creditorName
    if (amountMin) queryParams.amountMin = amountMin
    if (amountMax) queryParams.amountMax = amountMax
    
    return request({
      url: '/admin/debts',
      method: 'get',
      params: queryParams
    })
  },

  // 获取债务详情
  getDebtById(id) {
    return request({
      url: `/admin/debts/${id}`,
      method: 'get'
    })
  },

  // 创建债务
  createDebt(data) {
    return request({
      url: '/admin/debts',
      method: 'post',
      data
    })
  },

  // 更新债务
  updateDebt(id, data) {
    return request({
      url: `/admin/debts/${id}`,
      method: 'put',
      data
    })
  },

  // 删除债务
  deleteDebt(id) {
    return request({
      url: `/admin/debts/${id}`,
      method: 'delete'
    })
  },

  // 更新债务状态
  updateDebtStatus(id, status) {
    return request({
      url: `/admin/debts/${id}/status`,
      method: 'put',
      data: { status }
    })
  },

  // 获取债务统计
  getDebtStats() {
    return request({
      url: '/admin/debts/stats',
      method: 'get'
    })
  }
}

export default debtApi
